export class MasterStatsModel {
    completed: number
    in_progress: number
    planned: number
    total_task: number
    unassigned:number
    rejected:number
    feedback_count:number
}
 

export class StatsDisplayModel {
    completed: boolean
    in_progress: boolean
    planned: boolean
    unassigned:boolean
    rejected:boolean
}
 